import * as React from 'react'
import { FunctionComponent } from 'react'
import { ISpinnerProps, IStackProps, IStackStyles, Spinner, Stack } from '@fluentui/react'
import { useTranslation } from 'react-i18next'

const stackStyles: IStackStyles = {
    root: { height: '100%' },
}

type Props = ISpinnerProps & {
    stackProps?: IStackProps
}

const Loading: FunctionComponent<Props> = props => {
    const { t: translate } = useTranslation()

    return (
        <Stack
            horizontalAlign="center"
            verticalAlign="center"
            styles={stackStyles}
            tokens={{ padding: 'l2' }}
            {...props.stackProps}
        >
            <Spinner label={translate('base.loading')} {...props} />
        </Stack>
    )
}

export default Loading
